export default "__VITE_ASSET__D$WUXzTC__"